import { createSelector } from 'reselect';
import { get, toString } from 'lodash/fp';

function getEntity(lineups, { lineupId, id, isTeam }) {
  const lineup = lineups.find(l => l.id === lineupId);

  if (!lineup) {
    return {};
  }

  const { selection = {}, slate = {} } = lineup;

  const item = isTeam
    ? (selection.teams || []).find(team => toString(team.id) === id)
    : (selection.players || []).find(player => toString(player.id) === id);

  if (!item) {
    return {};
  }

  const game = (slate.games || []).find(g => g.id === item.game_id);

  return {
    onesportCompetitionId: get('competition.onesport_id', game),
    onesportEntityId: item.onesport_id,
    onesportGameId: game.onesport_id,
    onesportSportId: toString(get('competition.competition_type.sport.onesport_id', game))
  };
}

const lineupEntitySelector = createSelector(
  get('myTeams.lineups'),
  (state, { lineupId, id, isTeam }) => ({ lineupId, id, isTeam }),
  getEntity
);

export default lineupEntitySelector;
